import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import copyToClipboard from 'copy-to-clipboard';

import { Button } from '../../../../../../../components';
import { selectMediaExport } from '../../../../../../../store/modules/articles/selectors';
import { notify } from '../../../../../../../store/modules/notifications/actions';
import useStyles from '../styles';

const CopyVideoTokenAction = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { media } = useSelector(selectMediaExport);

  const clickHandler = useCallback((token: string) => {
    return () => {
      if (copyToClipboard(token)) {
        dispatch(
          notify({
            type: 'info',
            icon: 'copy',
            message: 'Video ID Token copied.',
          }),
        );
      } else {
        dispatch(
          notify({
            type: 'error',
            icon: 'copy',
            message: 'Video ID Token copying failed.',
          }),
        );
      }
    };
  }, [dispatch]);

  if (media && media.ref.video) {
    const { video } = media.ref;
    return (
      <Button
        color="default"
        variant="text"
        className={classes.groupAction}
        onClick={clickHandler(video?.playback_token || '')}
      >
        Copy
      </Button>
    );
  }

  return null;
};

export default CopyVideoTokenAction;
